<template lang="pug">
section.section-content.section-content--data-usage
    .box
        header.box__header.no-border.flex.items-center.justify-between
            .header-meta
                h2.subheading Personal Information
            .header-cta

        .box__body.p-4
            template(v-if="load_data_status_profile.status === 'loading' && load_data_status_profile_count.identity === 'loading'")
                Loading(show="true")
            .block.mb-4(v-else)
                .flex.flex-wrap.-mx-4   
                    .block.px-4(class="w-full lg:w-1/5")
                        .block.mb-4
                            span.text-light Name
                            //- h3.monospace {{ profile_identity.name ? profile_identity.name : '-' }}
                            h3.monospace
                                router-link.link-text(v-if="profile_identity.name && profile_identity.name.length > 0" :to="'/search-by-name/'+ encrypt(profile_identity.name, 'name')" target="_blank")
                                    | {{ profile_identity.name }}
                                template(v-else) -

                        .block.mb-4
                            span.text-light MSISDN
                            h3.monospace
                                template(v-if="profile_identity.phone && profile_identity.phone.length > 0")
                                    template(v-for="(msisdn, index) in profile_identity.phone")
                                        span {{ index ? ', ': '' }}
                                        router-link.link-text(:to="'/result/'+ encrypt(msisdn +'&&msisdn') +'/recent-location'" target="_blank") {{ msisdn }}
                                template(v-else) -

                        .block.mb-4
                            span.text-light Gender
                            h3.monospace {{ profile_identity.gender ? profile_identity.gender : '-' }}
                        .block.mb-4
                            span.text-light Religion
                            h3.monospace {{ profile_identity.religion ? profile_identity.religion : '-' }}
                        .block.mb-4
                            span.text-light Marital
                            h3.monospace {{ profile_identity.marital_status ? profile_identity.marital_status : '-' }}
                        .block.mb-4
                            span.text-light Job
                            h3.monospace {{ profile_identity.occupation ? profile_identity.occupation : '-' }}
                        .block.mb-4
                            span.text-light Blood Type
                            h3.monospace {{ profile_identity.blood ? profile_identity.blood : '-' }}

                    .block.px-4(class="w-full lg:w-1/5")
                        .block.mb-4
                            span.text-light DOB
                            h3.monospace {{ profile_identity.birth_date ? profile_identity.birth_date : '-' }}
                        .block.mb-4
                            span.text-light POB
                            h3.monospace {{ profile_identity.birth_place ? profile_identity.birth_place : '-' }}
                        .block.mb-4
                            span.text-light KTP/NIK
                            h3.monospace {{ profile_identity.ktp ? profile_identity.ktp : '-' }}
                        .block.mb-4
                            span.text-light NKK
                            h3.monospace {{ profile_identity.family_id ? profile_identity.family_id : '-' }}
                        .block.mb-4
                            span.text-light Mother
                            h3.monospace {{ profile_identity.mothers_name ? profile_identity.mothers_name : '-' }}
                        .block.mb-4
                            span.text-light Father
                            h3.monospace {{ profile_identity.fathers_name ? profile_identity.fathers_name : '-' }}
                        .block.mb-4
                            span.text-light Status
                            h3.monospace {{ profile_identity.status ? profile_identity.status : '-' }}

                    .block.px-4(class="w-full lg:w-1/5")
                        .block.mb-4
                            span.text-light Province
                            h3.monospace {{ profile_identity.address_province ? profile_identity.address_province : '-' }}
                        .block.mb-4
                            span.text-light Address
                            h3.monospace {{ profile_identity.address ? profile_identity.address : '-' }}
                        .block.mb-4
                            span.text-light City
                            h3.monospace {{ profile_identity.address_district ? profile_identity.address_district : '-' }}
                        .block.mb-4
                            span.text-light Sub District
                            h3.monospace {{ profile_identity.address_sub_district ? profile_identity.address_sub_district : '-' }}
                        .block.mb-4
                            span.text-light Village
                            h3.monospace {{ profile_identity.address_urban_village ? profile_identity.address_urban_village : '-' }}
                        .block.mb-4
                            span.text-light RT/RW
                            h3.monospace {{ profile_identity.address_rt_rw ? profile_identity.address_rt_rw : '-' }}
                        .block.mb-4
                            span.text-light Zip Code
                            h3.monospace {{ profile_identity.zip ? profile_identity.zip : '-' }}


                    .block.px-4(class="w-full lg:w-1/5")
                        .block.mb-4
                            span.text-light Nationality
                            h3.monospace {{ profile_identity.nationality ? profile_identity.nationality : '-' }}
                        .block.mb-4
                            span.text-light NOK
                            h3.monospace {{ profile_identity.nok ? profile_identity.nok : '-' }}
                        .block.mb-4
                            span.text-light Print At
                            h3.monospace {{ profile_identity.print ? profile_identity.print : '-' }}
                        .block.mb-4
                            span.text-light Zodiac
                            h3.monospace {{ profile_identity.zodiac ? profile_identity.zodiac : '-' }}
                        //- .block.mb-4
                            span.text-light Weton
                            h3.monospace {{ profile_identity.weton ? profile_identity.weton : '-' }} Sabtu Kliwon
                    .block.px-4(class="w-full lg:w-1/5 mobile-order-top")
                        .block.mb-4(v-if="profile_identity.photo && profile_identity.photo != '-'")
                            img(:src="profile_identity.photo" @error="getDefaultImage")
                        .block.mb-4(v-else)
                            //- img(src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQDL6TQy3sIznqksMdJuEJwG_fthjL0oBiyEPf1_mR2KUmI-zIX&usqp=CAU")
                            img(:src="defaultImage")

</template>

<script>
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
// import NoDataAvailable from '@/components/NoDataAvailable.vue';
import { encrypt } from '@/util/crypto';

export default {
    name: 'PersonalProfile',
    components: {
        Loading,
        // NoDataAvailable,
    },
    data: function() {
        return {
            defaultImage: this.$store.getters.getDefaultImage,
            msisdns: ['6285640108325', '6285640108325', '6285640108325','6285640108325', '6285640108325'],
        };
    },
    computed: {
        ...mapState([
          'load_data_status_profile',
          'load_data_status_profile_count',
          'profile_identity',
        ]),
    },
    methods: {
        getDefaultImage(e) {
            e.target.src = this.defaultImage;
        },
        encrypt(key, type) {
            return encrypt(key + '&&' + type);
        },
    },
}
</script>

<style lang="sass">

</style>
